// import React from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter as Router } from "react-router-dom";
// import App from "./App";
// import { ToastContainer } from "react-toastify";
// import { AuthProvider } from "./context/AuthContext";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <>
//     <ToastContainer position="top-right" autoClose={3000} />
//     <Router>
//       <AuthProvider>
//         <App />
//       </AuthProvider>
//     </Router>
//   </>
// );


import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer position="top-right" autoClose={3000} />
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </>
);


// import React from "react";
// import ReactDOM from "react-dom/client";
// // import { BrowserRouter as Router } from "react-router-dom";
// import { HashRouter } from "react-router-dom";
// import App from "./App";
// import { ToastContainer } from "react-toastify";
// import { AuthProvider } from "./context/AuthContext";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <>
//     <ToastContainer position="top-right" autoClose={3000} />
//     <HashRouter> 
//       <AuthProvider>
//         <App />
//       </AuthProvider>
//     </HashRouter>
//   </>
// );
